import React from 'react';

export type TextareaProps =
  React.TextareaHTMLAttributes<HTMLTextAreaElement> & {
    className?: string;
  };

function Textarea(
  { className, ...props }: TextareaProps,
  ref: React.ForwardedRef<HTMLTextAreaElement>
) {
  return (
    <textarea {...props} className={`input-layer ${className}`} ref={ref} />
  );
}

const forwardRef = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  Textarea
);

export { forwardRef as Textarea };
